import React, { useState } from "react";
import { Container, Card, Form, Row, Col, InputGroup } from "react-bootstrap";
import { isInIframe } from "../../utils/is-in-iframe";
import { ToolsHeader } from "../components/ToolsHeader";
import { Box } from "./colorConverterStyle";

const ColorConverter: React.FC = () => {
  const [hex, setHex] = useState("#ffffe0");
  const [rgb, setRgb] = useState("rgb(255, 255, 224)");
  const [isValid, setIsValid] = useState(true);

  const convertHexToRgb = (hexVal: string): string => {
    let hexClean = hexVal.replace("#", "");
    if (hexClean.length === 3) {
      hexClean = hexClean
        .split("")
        .map((c) => c + c)
        .join("");
    }
    const r = parseInt(hexClean.substring(0, 2), 16);
    const g = parseInt(hexClean.substring(2, 4), 16);
    const b = parseInt(hexClean.substring(4, 6), 16);
    return `rgb(${r}, ${g}, ${b})`;
  };

  const handleHexChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setHex(value);

    const hexRegex = /^#([0-9A-Fa-f]{3}|[0-9A-Fa-f]{6})$/;
    if (hexRegex.test(value)) {
      const rgbVal = convertHexToRgb(value);
      setRgb(rgbVal);
      setIsValid(true);
    } else {
      setRgb("");
      setIsValid(false);
    }
  };

  return (
    <Box>
      <Container className={`p-0  ${isInIframe && "interDisplay"}`}>
        <Row className={`justify-content-center`}>
          <Col md={6}>
            {!isInIframe && (
              <ToolsHeader
                title="HEX to RGB Color Code Converter"
                description="Effortlessly decode HEX colors to RGB values — perfect for
                designers and developers."
              />
            )}
            {/* <div className="text-center mb-4">
              <h2 style={{ fontWeight: 700 }}>
                HEX to RGB Color Code Converter
              </h2>
              <p className="text-muted" style={{ fontSize: "1.05rem" }}>
                Effortlessly decode HEX colors to RGB values — perfect for
                designers and developers.
              </p>
            </div> */}
            <Card
              style={{
                borderRadius: "16px",
                boxShadow: "0 0 12px rgba(0,0,0,0.1)",
                margin: 0,
                padding: "1rem",
              }}
            >
              <Card.Body className="p-0">
                <Form>
                  <Form.Group className="mb-4">
                    <Form.Label>
                      <strong>Enter HEX Code</strong>
                    </Form.Label>
                    <InputGroup>
                      <Form.Control
                        type="text"
                        placeholder="#FFFFE0"
                        value={hex}
                        onChange={handleHexChange}
                        isInvalid={!isValid}
                        style={{ borderRadius: "8px" }}
                      />
                    </InputGroup>
                    <Form.Control.Feedback type="invalid">
                      Enter a valid HEX code (e.g., #ffcc00 or #fc0)
                    </Form.Control.Feedback>
                  </Form.Group>

                  <Form.Group className="mb-4">
                    <Form.Label>
                      <strong>RGB Output</strong>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="rgb(255, 255, 224)"
                      value={rgb}
                      readOnly
                      style={{
                        backgroundColor: "#f8f9fa",
                        borderRadius: "8px",
                      }}
                    />
                  </Form.Group>

                  <div
                    style={{
                      height: "80px",
                      borderRadius: "12px",
                      backgroundColor: isValid ? hex : "#f8f9fa",
                      border: "1px solid #ccc",
                      textAlign: "center",
                      lineHeight: "80px",
                      fontWeight: 600,
                      color: "#333",
                    }}
                  >
                    {isValid ? hex.toUpperCase() : "Invalid HEX Code"}
                  </div>
                </Form>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </Box>
  );
};

export default ColorConverter;
